import React from "react";
import { useHistory } from "react-router-dom";
import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { Helmet } from "react-helmet-async";

const NotFound = () => {
  const history = useHistory();
  const BRAND = "#286328"; // brand color

  const pageBg = useColorModeValue("gray.100", "gray.900");
  const border = useColorModeValue("blackAlpha.100", "whiteAlpha.200");
  const muted = useColorModeValue("gray.600", "gray.400");
  const title = useColorModeValue("gray.700", "gray.100");

  return (
    <>
      <Helmet>
        <title>404 – Page Not Found | NOMAD360</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <Box h="100vh" position="relative" overflow="hidden" bg={pageBg} py={{ base: 8, md: 12 }}>
        {/* Soft brand blobs on main box */}
        <Box position="absolute" inset="0" pointerEvents="none" zIndex={0}>
          <Box
            position="absolute"
            right={{ base: "-120px", md: "-80px" }}
            top={{ base: "40%", md: "15%" }}
            w={{ base: "260px", md: "340px" }}
            h={{ base: "260px", md: "340px" }}
            borderRadius="full"
            bg={BRAND}
            filter="blur(90px)"
            opacity={0.35}
          />
          <Box
            position="absolute"
            left={{ base: "-140px", md: "-100px" }}
            bottom={{ base: "-80px", md: "-60px" }}
            w={{ base: "320px", md: "420px" }}
            h={{ base: "320px", md: "420px" }}
            borderRadius="full"
            bg={BRAND}
            filter="blur(110px)"
            opacity={0.18}
          />
        </Box>

        <Container maxW="7xl" position="relative" zIndex={1} h="100%">
          <Flex direction="column" h="100%">
            {/* Centered Content */}
            <Flex
              direction="column"
              align="center"
              textAlign="center"
              justify="center"
              flex="1"
            >
              <Heading
                as="div"
                fontSize={{ base: "7xl", md: "8xl" }}
                fontWeight="semibold"
                color={BRAND}
                mb={3}
                letterSpacing="tight"
              >
                404
              </Heading>

              <Heading as="h1" size="md" mb={2} color={title}>
                Page Not Found.
              </Heading>

              <Text fontSize="sm" color={muted} mb={6}>
                Sorry, we can’t find the page you’re looking for.
              </Text>

              <Button
                onClick={() => history.push("/")}
                borderRadius="999px"
                px={6}
                h="42px"
                bg={BRAND}
                color="white"
                _hover={{ opacity: 0.9, transform: "translateY(-1px)" }}
                boxShadow="md"
                transition="all 0.15s ease"
              >
                Back to Home
              </Button>
            </Flex>

            {/* Footer */}
            <Flex
              align="center"
              justify="center"
              py={6}
              borderTopWidth="1px"
              borderColor={border}
            >
              <Text fontSize="xs" color={muted}>
                © 2024-2025 NOMAD360™. All rights reserved.
              </Text>
            </Flex>
          </Flex>
        </Container>
      </Box>
    </>
  );
};

export default NotFound;
